
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class FieldError extends Vue {
  @Prop({ required: true }) errorMessage!: string

  get state (): boolean | null {
    return this.errorMessage ? false : null
  }
}
